import { differenceInMinutes } from 'date-fns';
import { Timestamp } from 'firebase/firestore';

export class NtaFile {
	facilityId: string;

	fileId: string;

	facilityType?: string;

	url: string;

	blob: Blob;

	patientId: string;

	uploadDateTime: Date;

	uploadedByName: string;

	generatedDateTime: Date;

	generatedByName: string;

	uploadedBy: string;

	filename: string;

	scanComplete = false;

	processing = false;

	runningEmbeddings = false;

	embeddingsCreatedCount = 0;

	chunkCount = 0;

	foundCategoryCount = 0;

	scanMethod: 'pdf' | 'http' | 'tesseractTask';

	scanCompleteTime: Date;

	pageCount = 0;

	startPage = 0;

	splitFile = false;

	error = false;

	timedOut = false;

	errorPages: number[] = [];

	content?: string;

	originalContent?: string;

	summarizing: boolean;

	generating: boolean;

	mappedProperties?: string[];

	configId?: string;

	category?: string;

	generatedDocumentId?: string;

	packetId?: string;

	attachedFilenames?: string;

	hideActionButtons = false;

	get scanDuration() {
		return differenceInMinutes(this.scanCompleteTime, this.uploadDateTime);
	}

	constructor(partial?:Partial<NtaFile>) {
		if (partial) {
			Object.assign(this, partial);
			if (partial.uploadDateTime instanceof Timestamp) {
				this.uploadDateTime = partial.uploadDateTime.toDate();
			}
			if (partial.scanCompleteTime instanceof Timestamp) {
				this.scanCompleteTime = partial.scanCompleteTime.toDate();
			}
			if (partial.generatedDateTime instanceof Timestamp) {
				this.generatedDateTime = partial.generatedDateTime.toDate();
			}
		}
	}
}
